module.exports = __webpack_public_path__ + "img/home_fitness2.2841fbd1.jpg";